let uuid = localStorage.uuid || 0
let rolID = localStorage.rolID || 0

export default {
  url: 'https://gestionibec.com/api/1.0/',
  // url: 'http://localhost:8088/app/api/1.0/',
  sufix: '?user_id=' + uuid + '&rol_id=' + rolID,
  token_renewal_route: 'user/renew-authorization/',
  roles: [
    'superadmin',
    'administrator',
    'supervisor',
    'commerce',
    'installer',
    'guest',
    'manager',
    'responsible'
  ]
}



// WEBPACK FOOTER //
// ./src/config/api.js